import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'login-recovery',
  templateUrl: '../../templates/partials/pass-recovery.html'
})
export class PassRecoveryComponent{

    @Output() loginState = new EventEmitter();

    changeLoginState(state){
        //this.state = 'recovery';
        this.loginState.emit(state);
    }
}


// WEBPACK FOOTER //
// ./src/app/modules/login/components/dummy/pass-recovery.component.ts